import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Accordion from '../../../../components/Accordion';
import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import Divider from '../../../../components/Divider';
import Input from '../../../../components/Inputs/Input';
import Select from '../../../../components/Inputs/Select';

import { useGlobal } from '../../../../contexts/Global/context';

import validators from '../../../../utils/defaultValidators';

import createPayload from './createPayload';
import translate from './translate';

import validate from '../../../../utils/validateForm';

import {
    alterarCentroCusto,
    getEnderecoByCep,
    getEstados,
    getMunicipios,
    inserirCentroCusto,
} from '../../../../services';

import { checkIsSupport, cloneObject } from '../../../../utils';

import FormContainer from '../../../../components/FormContainer';
import { EmptyField } from '../../../../components/Inputs/styles';
import { ContainerButton, PageContainer } from '../../../../styles/styles';

const addressSchema = {
    estado: {
        sigla: '',
        municipios: [
            {
                nome: '',
                bairros: [
                    {
                        nome: '',
                    },
                ],
            },
        ],
    },
    logradouro: '',
    tipoLogradouro: '',
};

const PATH_LIST_COST_CENTERS = './selecionar_centro_custo';
const EDIT_MESSAGE = 'Você alterou dados de um centro de custo!';
const ADD_MESSAGE = 'Você adicionou um centro de custo!';

function FormCentroDeCusto({ location: { dataCostCenter } }) {
    const history = useHistory();

    const { dataActiveContract, setShowSupportModal } = useGlobal();

    const translatedData = translate(dataCostCenter);

    const [dataForm, setDataForm] = useState(cloneObject(translatedData));
    const [cepLoading, setCepLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alreadySearchedCep, setAlreadySearchedCep] = useState(dataForm.cep.value);
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        async function loadStates() {
            const estados = (await getEstados()) || [];

            let municipios = [];

            if (dataForm.uf.value) {
                municipios = await getMunicipios(dataForm.uf.value);
            }

            const initialValues = {
                uf: { ...dataForm.uf, options: estados },
                city: { ...dataForm.city, options: municipios },
            };

            setDataForm({
                ...dataForm,
                ...initialValues,
            });
        }

        loadStates();
    }, []);

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        if (['cellphone', 'comercialPhone'].includes(key) && form[key].value?.length <= 1) {
            form[key].value = '';
            form[key].unmaskedValue = '';
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (form[key].required || (!form[key].required && !!form[key].value)) {
            if (typeof validators[key] === 'function') validators[key](form);
        }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeState(state) {
        const municipios = (await getMunicipios(state)) || [];

        return municipios;
    }

    async function handleChangeCep(event) {
        const { value, unmaskedValue } = event;
        console.log(event)

        setCepLoading(true);
        let foundCep = true;
        const response = await getEnderecoByCep(unmaskedValue) || [];
        const zips = []

        console.log(response)

        // Para zerar o endereço caso seja digitado um cep inválido
        if (response.estado.municipios[0].bairros[0].nome === null) {
            zips.push({ ...addressSchema });
            foundCep = false;
        }

        const dataAddress = {
            address: {
                ...dataForm.address,
                value: response.tipoLogradouro ? `${response.tipoLogradouro}. ${response.logradouro}` : '',
            },
            hood: { ...dataForm.hood, value: response.estado.municipios[0].bairros[0].nome },
            uf: { ...dataForm.uf, value: response.estado.sigla, lookup: response.estado.nome, sigla: response.estado.sigla },
            city: {
                ...dataForm.city,
                value: response.estado.municipios[0].codigo,
                lookup: response.estado.municipios[0].nome,
            },
            cep: {
                ...dataForm.cep,
                unmaskedValue,
                value,
                error: !foundCep && 'Os dados de endereço não foram localizados a partir do CEP informado',
            },
        };

        if (foundCep) {
            dataAddress.address.error = '';
            dataAddress.hood.error = '';
            dataAddress.uf.error = '';
            dataAddress.city.error = '';
        }

        setCepLoading(false);
        setAlreadySearchedCep(true);

        return dataAddress;
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        let field = { ...cloneObject(dataForm[id]), value, lookup, unmaskedValue, error: '', ...rest };

        const city = cloneObject(dataForm.city);

        if (id === 'uf') {
            const municipios = await handleChangeState(value);

            city.error = '';
            city.value = '';
            city.options = municipios;
        }

        let dataAddress = {};

        if (id === 'cep' && unmaskedValue.length === 8 && unmaskedValue !== dataForm.cep.value) {
            dataAddress = (await handleChangeCep(event)) || {};

            if (dataAddress.uf.value) document.getElementById('addressNumber').focus();

            const municipios = await handleChangeState(dataAddress.uf.value);

            dataAddress.city.options = municipios;

            field = dataAddress.cep;
        }

        const newDataForm = {
            ...dataForm,
            city,
            ...dataAddress,
            [id]: field,
        };

        setDataForm(newDataForm);
    }

    function handleErrorRequest() {
        setAlerts([
            {
                type: 1,
                title: `Ocorreu um erro ao ${dataCostCenter ? 'alterar' : 'incluir'} o centro e custo.`,
            },
        ]);

        setTimeout(() => {
            window.document.getElementById('page-content').scrollTo(0, 0);
        }, 100);
    }

    async function insertCostCenter(payload) {
        const response = await inserirCentroCusto(payload);

        if (response.sucesso) {
            history.push({
                pathname: PATH_LIST_COST_CENTERS,
                cameFromForm: true,
                message: ADD_MESSAGE,
            });

            return;
        }

        handleErrorRequest();
    }

    async function updateCostCenter(payload) {
        const response = await alterarCentroCusto(dataCostCenter.codigoTsCentroCusto, payload);

        if (response.sucesso) {
            history.push({
                pathname: PATH_LIST_COST_CENTERS,
                cameFromForm: true,
                message: EDIT_MESSAGE,
            });

            return;
        }

        handleErrorRequest();
    }

    async function handleFinish() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 300);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoading(true);

        const payload = createPayload(dataForm, dataActiveContract);

        if (dataCostCenter) {
            await updateCostCenter(payload);

            setLoading(false);

            return;
        }

        await insertCostCenter(payload);

        setLoading(false);
    }

    return (
        <>
            <PageContainer>
                {alerts.map((alert, index) => (
                    <Alert key={() => index} type={alert.type} title={alert.title} />
                ))}

                <Accordion title="Dados do centro de custo">
                    <FormContainer>
                        <Input
                            field={{ ...dataForm.costCenterCode, disabled: !!dataCostCenter }}
                            onChange={handleChangeInput}
                            onBlur={handleInputBlur}
                        />
                        <Input field={dataForm.costCenterName} onChange={handleChangeInput} onBlur={handleInputBlur} />

                        <Input
                            field={dataForm.costCenterInitials}
                            onChange={handleChangeInput}
                            onBlur={handleInputBlur}
                        />
                        <Input
                            field={dataForm.costCenterResponsible}
                            onChange={handleChangeInput}
                            onBlur={handleInputBlur}
                        />
                    </FormContainer>

                    <Divider />

                    <FormContainer>
                        <Input
                            field={{
                                ...dataForm.cep,
                                disabled: cepLoading,
                                loading: cepLoading,
                                icon: { name: 'search', type: 'round' },
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />

                        <EmptyField />

                        <Input
                            field={{
                                ...dataForm.address,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                        <Input field={dataForm.addressNumber} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        <Input field={dataForm.complement} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        <Input
                            field={{
                                ...dataForm.hood,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                        <Select
                            field={{
                                ...dataForm.uf,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                        <Select
                            field={{
                                ...dataForm.city,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                        <Input field={dataForm.email} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        <Input field={dataForm.cellphone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        <Input field={dataForm.comercialPhone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                        <Input field={dataForm.ramal} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </FormContainer>
                </Accordion>

                <ContainerButton>
                    <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                        Voltar
                    </Button>

                    <Button
                        id="continueStep"
                        loading={loading}
                        disabled={loading}
                        type="primary"
                        onClick={handleFinish}
                    >
                        Finalizar
                    </Button>
                </ContainerButton>
            </PageContainer>
        </>
    );
}

export default FormCentroDeCusto;
